<template>
  <div class="auth-layout">
    <div class="auth-container">
      <!-- 左侧背景区域 -->
      <div class="auth-background">
        <div class="background-content">
          <div class="brand-section">
            <div class="brand-logo">
              <img src="/favicon.ico" alt="Cookpit" class="logo-image" />
            </div>
            <h1 class="brand-title">Cookpit管理后台</h1>
            <p class="brand-subtitle">运维、权限、配置与报告</p>
          </div>

          <div class="feature-list">
            <div class="feature-item">
              <div class="feature-icon">📈</div>
              <div class="feature-text">
                <h3>独立后台</h3>
                <p>管理功能与交易前端分离部署</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">🛡️</div>
              <div class="feature-text">
                <h3>统一认证</h3>
                <p>复用现有 JWT 登录与权限体系</p>
              </div>
            </div>
            <div class="feature-item">
              <div class="feature-icon">📊</div>
              <div class="feature-text">
                <h3>运维观测</h3>
                <p>集中处理系统配置、观测与日报</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧表单区域 -->
      <div class="auth-form-section">
        <div class="form-wrapper">
          <router-view />
        </div>

        <!-- 页脚 -->
        <div class="auth-footer">
          <p>&copy; 2026 Cookpit Admin. All rights reserved.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from "vue";

onMounted(() => {
  // 设置页面样式
  document.body.classList.add("auth-body");
});

// 组件卸载时清理
import { onUnmounted } from "vue";
onUnmounted(() => {
  document.body.classList.remove("auth-body");
});
</script>

<style lang="css" scoped>
.auth-layout {
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
}

.auth-container {
  width: 100%;
  max-width: 1200px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 600px;
}

.auth-background {
  background: linear-gradient(135deg, #5dc0f7 0%, #409eff 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 60px 40px;
  color: white;
  position: relative;
  overflow: hidden;
}

.background-content {
  position: relative;
  z-index: 1;
  text-align: center;
}

.brand-section {
  margin-bottom: 40px;
}

.brand-logo {
  margin-bottom: 20px;
}

.logo-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  padding: 16px;
}

.brand-title {
  font-size: 2.5rem;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.2;
}

.brand-subtitle {
  font-size: 1.125rem;
  opacity: 0.9;
  margin-bottom: 0;
}

.feature-list {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.feature-item {
  display: flex;
  align-items: center;
  gap: 16px;
  text-align: left;
}

.feature-icon {
  font-size: 2rem;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  flex-shrink: 0;
}

.feature-text h3 {
  margin: 0 0 4px 0;
  font-size: 1.125rem;
  font-weight: 600;
}

.feature-text p {
  margin: 0;
  opacity: 0.9;
  font-size: 0.875rem;
}

.auth-form-section {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px 40px 40px;
  position: relative;
}

.form-wrapper {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-footer {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #e5e7eb;
  margin-top: 20px;
}

.auth-footer p {
  margin: 0;
  color: #6b7280;
  font-size: 0.875rem;
}

/* 响应式设计 */
@media (max-width: 1023px) {
  .auth-container {
    grid-template-columns: 1fr;
    max-width: 480px;
  }

  .auth-background {
    display: none;
  }

  .auth-form-section {
    padding: 40px 24px 24px;
  }
}

@media (max-width: 575px) {
  .auth-layout {
    padding: 16px;
  }

  .auth-container {
    border-radius: 8px;
    min-height: auto;
  }

  .auth-form-section {
    padding: 32px 20px 20px;
  }
}

/* 全局样式覆盖 */
:global(.auth-body) {
  overflow: hidden;
}
</style>
